import { useEffect, useState } from "react";

/**
 * Returns a value after it has remained unchanged for the supplied delay.
 * @param value Value to debounce
 * @param delay Delay in milliseconds
 */
export const useDebouncedValue = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebouncedValue(value), delay);
    return () => window.clearTimeout(timer);
  }, [delay, value]);

  return debouncedValue;
};
